import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
const badges = ['📄 100% PDF', '⚡ Acceso en 5 min', '🇦🇷 Para barberos argentinos'];
export function Hero() {
  return <header className="relative overflow-hidden border-b border-ink-700 bg-ink-950" data-id="element-85" data-mp="4lqf8l2zysy8">
      <div className="hairline pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" data-id="element-86" data-mp="4jvx1ej41exu" />
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.55,
      ease: 'easeOut'
    }} className="relative mx-auto flex w-full max-w-3xl flex-col items-center px-5 py-8 text-center sm:px-8 sm:py-10" data-id="element-87" data-mp="1274nlnxyxe6p">
        <p className="display text-base tracking-[0.2em] text-bone" data-id="element-88" data-mp="neawf59c39m7">✂ Nuevo Nivel™</p>
        <p className="mt-1.5 text-[10px] font-bold uppercase tracking-[0.3em] text-ice" data-id="element-89" data-mp="3d33d6tuq0lin">
          Pack Blanco Perfecto
        </p>

        <h1 className="display mt-4 text-[26px] leading-[1.05] text-bone sm:text-4xl" data-id="element-90" data-mp="3j8ixl0k6uiv8">
          El blanco que siempre quisiste hacer.
          <span className="mt-2 block text-base text-ash sm:text-xl" data-id="element-91" data-mp="3o7vhbcfrj9tl">
            Te voy a enseñar exactamente el método que utilizo todos los días.
          </span>
        </h1>

        <p className="mx-auto mt-3 max-w-xl text-sm leading-snug text-ash sm:text-base" data-id="element-92" data-mp="3e963pvuwgbj5">
          El paso a paso completo para conseguir blancos limpios, uniformes y profesionales, sin
          improvisar en cada decoloración.
        </p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.12
      }} src="https://cdn.magicpatterns.com/uploads/qs3bm2soix2QGr6igmnetz/heylloyd-generated-1785305491545.png" alt="Pack Blanco Perfecto: tomo principal y los 5 bonos incluidos" className="mx-auto mt-4 h-auto w-full max-w-[180px] object-contain sm:max-w-[220px]" loading="eager" data-id="element-93" data-mp="35aausc0h0nc5" />

        <div className="mt-5 w-full max-w-md" data-id="element-94" data-mp="s3ckw8bgjfpi">
          <CtaButton size="md" data-id="element-95" data-mp="nbl0ygmt488c">Quiero mi pack ahora</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-96" data-mp="n9i35afexat2">
          {badges.map(badge => <li key={badge} className="border border-ink-700 bg-ink-900 px-2.5 py-1 text-[11px] font-semibold text-bone" data-id="element-97" data-mp="dd5cymj2tf32">
              {badge}
            </li>)}
        </ul>

        <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 text-[11px] font-semibold uppercase tracking-wider text-ash" data-id="element-98" data-mp="161jbd3e2udf5">
          <li className="flex items-center gap-1.5" data-id="element-99" data-mp="114swukhx7pvu">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-ice" aria-hidden="true" data-id="element-100" data-mp="x1wbim0zxfo7" /> Garantía 7 días
          </li>
          <li className="flex items-center gap-1.5" data-id="element-101" data-mp="3ltqe5h5gv3vm">
            <LockIcon className="h-3.5 w-3.5 text-ice" aria-hidden="true" data-id="element-102" data-mp="3hrd9kw2ghc0f" /> Pago seguro
          </li>
          <li className="flex items-center gap-1.5" data-id="element-103" data-mp="1x9kv8ohov8i9">
            <CreditCardIcon className="h-3.5 w-3.5 text-ice" aria-hidden="true" data-id="element-104" data-mp="1xaw0ksqs8obh" /> Mercado Pago
          </li>
        </ul>
      </motion.div>
    </header>;
}